// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2o5Tm","header":"ReportDetails_header__37ewq","title":"ReportDetails_title__31K3n","left":"ReportDetails_left__2ptyb"};